// extracted by mini-css-extract-plugin
export default {"header":"y-WJ9LK191P5xl+bFTf3Eg=="};